export function getNumber(arr1: any[], arr2: any) {
  return arr1.map((cub: any) => {
    return { ...cub, number: arr2[cub.text] }
  })
}
export function getActivated(arr1: any[], arr2: any) {
  return arr1.map((cub: any) => {
    return { ...cub, activated: Number(arr2[cub.text]) }
  })
}
